module.exports = __webpack_public_path__ + "img/T2.6e7186a5.png";